import routingCheckMiddleware from './routingCheck.middleware'
import gameStateMiddleware from './gameState.middleware'
import rosterMiddleware from './roster.middleware'
import equipmentMiddleware from './equipment.middleware'
import battleMiddleware from './battle.middleware'
import battleCalculationMiddleware from './battleCalculation.middleware'
import targetActorMiddleware from './targetActor.middleware'
import progressionMiddleware from './progression.middleware'

export default [
    routingCheckMiddleware,
    gameStateMiddleware,
    rosterMiddleware,
    equipmentMiddleware,
    battleMiddleware,
    battleCalculationMiddleware,
    targetActorMiddleware,
    progressionMiddleware,
]
